import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import styled from "styled-components";

const MarkdownBody = styled.div`
  font-family: "Oxanium", sans-serif;
  font-size: 0.95rem;
  line-height: 1.75;
  color: #3d4f5c;
  word-break: break-word;
  overflow-wrap: anywhere;
  max-width: 100%;

  pre,
  code {
    white-space: pre-wrap;
    word-break: break-word;
    overflow-wrap: anywhere;
    max-width: 100%;
  }

  pre {
    overflow-x: auto;
    background: #f4f2f7;
    border-radius: 8px;
    padding: 0.75rem 1rem;
  }

  h2 {
    font-size: 1.35rem;
    font-weight: 700;
    color: #084d6e;
    margin: 1.75rem 0 1rem;
    padding-bottom: 0.5rem;
    border-bottom: 2px solid rgba(158, 36, 128, 0.15);
  }

  h3 {
    font-size: 1.1rem;
    font-weight: 700;
    color: #084d6e;
    margin: 1.5rem 0 0.75rem;
  }

  p {
    margin: 0 0 0.85rem;
  }

  strong {
    font-weight: 700;
    color: #084d6e;
  }

  em {
    font-style: italic;
    color: #5a6b78;
  }

  hr {
    border: none;
    height: 1px;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(158, 36, 128, 0.35),
      transparent
    );
    margin: 1.5rem 0;
  }

  ul,
  ol {
    margin: 0 0 1rem;
    padding-left: 1.25rem;
    list-style: disc;
  }

  ol {
    list-style: decimal;
  }

  li {
    margin-bottom: 0.45rem;
  }

  li::marker {
    color: #9e2480;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin: 1rem 0 1.5rem;
    font-size: 0.88rem;
    overflow-x: auto;
    display: block;
  }

  thead {
    background: linear-gradient(135deg, #084d6e 0%, #9e2480 100%);
    color: #fff;
  }

  th,
  td {
    padding: 0.65rem 0.75rem;
    text-align: left;
    border: 1px solid #e2e8ee;
    white-space: nowrap;
  }

  tbody tr:nth-child(even) {
    background: #f8fafc;
  }

  @media (max-width: 768px) {
    font-size: 0.9rem;

    h2 {
      font-size: 1.2rem;
    }

    h3 {
      font-size: 1.02rem;
    }

    table {
      font-size: 0.8rem;
    }

    th,
    td {
      padding: 0.5rem;
      white-space: normal;
      word-break: break-word;
    }
  }
`;

function normalizeReportMarkdown(text) {
  if (!text) return "";

  return text
    .split(/\r?\n/)
    .map((line) => {
      // Linhas indentadas com 4+ espaços (ou tabs) viram bloco de código no
      // Markdown e estouram a largura. Convertendo em item de lista, o texto
      // quebra normalmente e a ênfase (*itálico*) é interpretada.
      const indented = line.match(/^(?: {4,}|\t+)(\S.*)$/);
      if (indented) {
        return `- ${indented[1].trim()}`;
      }
      return line;
    })
    .join("\n");
}

function ReportMarkdown({ content }) {
  return (
    <MarkdownBody>
      <ReactMarkdown remarkPlugins={[remarkGfm]}>
        {normalizeReportMarkdown(content)}
      </ReactMarkdown>
    </MarkdownBody>
  );
}

export default ReportMarkdown;
